import React from "react";

export default function SQL_Intro() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Intro</h1>
      <p>This is the SQL_Intro component generated from the SQL JSON.</p>
    </div>
  );
}
